import React from 'react';
import { ResponsiveContainer, BarChart, Bar, YAxis } from 'recharts';

export default function ChartVolumeBar({ data }) {
  return (
    <div className="h-full w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 0, right: 25, left: 25, bottom: 0 }}>
          <YAxis hide yAxisId="volume" />
          <Bar dataKey="volume" yAxisId="volume" fill="#60a5fa" radius={[2,2,0,0]} barSize={2} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
